export default __webpack_public_path__ + "56d90471e9765284dd4d5d805d60cd03.svg";